import { render, staticRenderFns } from "./FinanceDetailWidgetClient.vue?vue&type=template&id=2bb5f05f&scoped=true&"
import script from "./FinanceDetailWidgetClient.vue?vue&type=script&lang=js&"
export * from "./FinanceDetailWidgetClient.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDetailWidgetClient.vue?vue&type=style&index=0&id=2bb5f05f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5f05f",
  null
  
)

export default component.exports